import Model from '@/dc-it/models/Model'
import Field from '@/dc-it/types/Field'

export default class Country extends Model {
    endpoint = 'countries';

    fields = [
      new Field('id', 'Código').disabled(),
      new Field('name', 'Nombre'),
    ];

    clone = () => Country;
}
